import {
  memo, useEffect, useState, useRef,
} from 'react';

import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ikea from 'ikea-jssdk';
import { AidQuestionnaire } from '@aidesign/store';
import { supportSaveDesign } from '@/pages/offer/useDetail';
import gioTrack, { getPageInfo } from '@/utils/track';
import { getPlatform } from '@/utils/rules/const';

import { ReactComponent as HeadClose } from '@/assets/headClose.svg';
import findCoworker from '@/assets/find_coworker.svg';
import style from './exitDesignDrawer.module.scss';

const SurveyParamsConfig = {
  stepone: 'stepone',
  steptwo: 'steptwo',
  stepthree: 'stepthree',
  doorPlank: 'doorPlank',
  mesa: 'mesa',
  drawer: 'drawer',
  recommendStorage: 'drawer',
  offer: 'offer',
};

function ExitDesignDrawer(props) {
  // title标题，content提示文字，buttonText按钮文字（obj）,buttonFunc按钮处理函数,close 点击叉号关闭，closeFn 点击遮罩关闭,reverse互换按钮在调整页用到
  const {
    close,
    closeFn,
    isShowSaveBtn,
    exitAndSaveDesign,
    exit,
    goToCSC,
  } = props;
  const { t } = useTranslation();
  const surveyRef = useRef(null);
  const [exitText, setExitText] = useState(t('exit'));

  // 关闭弹窗
  const handleClose = async () => {
    closeFn(false);
  };

  const handleExit = async (isSaveBtn = false) => {
    await surveyRef.current?.confirm(async (questionnaire, selected, remark) => {
      const { href } = window.location;
      const pageInfo = getPageInfo();
      if (!pageInfo) return;
      const hasDesignCode = href.includes('offer');
      // eslint-disable-next-line prefer-template
      const remarkStr = remark && ('-' + remark);
      // const remarkStr = remark;
      gioTrack('clickData', {
        eventType_var: 'click',
        platform_var: getPlatform[localStorage.getItem('currentPlatform')],
        pageType_var: pageInfo.pageType,
        pageId_var: href,
        pageName_var: pageInfo.pageName,
        module_var: 'questionnaire_popup',
        modulePosition_var: '-',
        objectId_var: hasDesignCode ? window.sessionStorage.getItem('uniqueCode') || '-' : '-',
        objectType_var: 'exit',
        // eslint-disable-next-line no-nested-ternary
        objectName_var: isSaveBtn ? '退出并保存设计方案' : selected.length > 0 ? '提交并退出' : '直接退出',
        attributeName1_var: 'question_var',
        attributeValue1_var: Array.isArray(questionnaire) ? questionnaire.join('-') : '-',
        attributeName2_var: 'answer_var',
        attributeValue2_var: (selected.join('-') + remarkStr) || '-',
      });
    });
  };

  const [surportVersion, setSupportSaveDesign] = useState(true);

  useEffect(() => {
    supportSaveDesign().then((res) => {
      setSupportSaveDesign(res);
    });
    ikea.isLogin().then((res) => {
      if (res && res.value === false) {
        setSupportSaveDesign(false);
      }
    });
  }, []);

  const getSurveyParams = () => {
    const currentKey = Object.keys(SurveyParamsConfig).find((item) => window.location.href.includes(item)) || 'index';
    return SurveyParamsConfig[currentKey];
  };

  return (
    <div>
      <div
        className={style.cover}
        onClick={handleClose}
        role="presentation"
      />
      <div className={`${style.container}`}>
        <div className={style.head}>
          {t('noDesign')}
          {
            close && (
            <div className={style.close} aria-hidden onClick={handleClose}>
              <HeadClose />
            </div>
            )
          }
        </div>
        {/* {
          questionnaire && (
            <div aria-hidden onClick={toQuestionnaire}>
              <img className={style['question-banner']} src={ResearchBanner} alt="ResearchBanner" />
            </div>
          )
        } */}
        <div
          aria-hidden
          onClick={() => {
            goToCSC();
          }}
        >
          <img className={style['question-banner']} src={findCoworker} alt="ResearchBanner" />
        </div>
        <AidQuestionnaire
          onChange={(options, selected) => {
            if (selected.length > 0) {
              setExitText(t('saveAndExit'));
            } else {
              setExitText(t('exit'));
            }
          }}
          title="请告诉我们退出工具的原因（可多选）"
          pageName={getSurveyParams()}
          prdline="kitchen"
          ref={surveyRef}
          prefix={process.env.REACT_APP_BASE_URL}
        />
        {/* <div className={style.contactCsc}>
          <div className={style.cscLeft}>
            <div className={style.quitSubTitle}>
              {t('freeDesigner')}
            </div>
            <div
              aria-hidden
              className={style.blackBtn}
              onClick={goToCSC}
            >
              {t('onDesigner')}
            </div>
          </div>
          <div className={style.cscRight}>
            <img className={style.quitDesigner} src={DesignerImage} alt="designer" />
          </div>
        </div> */}
        <div className={style['button-wrap']}>
          <div
            role="presentation"
            onClick={() => {
              handleExit().then(() => {
                exit();
              });
            }}
            className={`${style['reset-button']} ${(!surportVersion || !isShowSaveBtn) && style.surportVersion}`}
          >
            { exitText }
          </div>
          {
            isShowSaveBtn && surportVersion && (
              <div
                role="presentation"
                onClick={() => {
                  handleExit(true).then(() => {
                    exitAndSaveDesign();
                  });
                }}
                className={`${style['submit-button']}`}
              >
                {t('exitAndSave')}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

ExitDesignDrawer.propTypes = {
  close: propTypes.bool,
  closeFn: propTypes.func,
  exit: propTypes.func,
  isShowSaveBtn: propTypes.bool,
  exitAndSaveDesign: propTypes.func,
  goToCSC: propTypes.func,
};

ExitDesignDrawer.defaultProps = {
  close: false,
  closeFn() {},
  isShowSaveBtn: true,
  exitAndSaveDesign() { },
  exit() { },
  goToCSC() { },
};

export default memo(ExitDesignDrawer);
